import axios from 'axios';
import { clearAdminToken, getAdminToken } from '../utils/adminAuth';

const tokenUsageApi = axios.create({
  baseURL: '/api/v1/admin/token-usage',
  withCredentials: true
});

tokenUsageApi.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

tokenUsageApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAdminToken();
      if (typeof window !== 'undefined') {
        window.location.href = '/web/admin-login';
      }
    }
    return Promise.reject(error);
  }
);

export const getTokenUsageOverview = async (params) => {
  const response = await tokenUsageApi.get('/overview', { params });
  return response.data;
};

export const getTokenUsageBreakdown = async (params) => {
  const response = await tokenUsageApi.get('/breakdown', { params });
  return response.data;
};

export const getTokenUsageEvents = async (params) => {
  const response = await tokenUsageApi.get('/events', { params });
  return response.data;
};

export const getTokenUsageFilters = async () => {
  const response = await tokenUsageApi.get('/filters');
  return response.data;
};

export default tokenUsageApi;
